const KEYS = {
  CONVERSATIONS: 'conversations',
  DETAILS: 'details',
  MESSAGES: 'messages',
  SEARCH: 'search',
};

export const getConversationsQueryKey = () => [KEYS.CONVERSATIONS] as const;

export const getConversationQueryKey = (id: ID) =>
  [...getConversationsQueryKey(), KEYS.DETAILS, id] as const;

export const getConversationMessagesQueryKey = (id: ID, selectedMessageId: ID | null = null) =>
  [...getConversationQueryKey(id), KEYS.MESSAGES, { selectedMessageId }] as const;

export const getConversationSearchQueryKey = (searchQuery: string) =>
  [...getConversationsQueryKey(), { searchQuery }] as const;
